export const ImageIcon = () => (
    <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M0 3.5C0 2.39688 0.896875 1.5 2 1.5H14C15.1031 1.5 16 2.39688 16 3.5V13.5C16 14.6031 15.1031 15.5 14 15.5H2C0.896875 15.5 0 14.6031 0 13.5V3.5ZM10.1187 6.82812C9.97812 6.62187 9.74687 6.5 9.5 6.5C9.25313 6.5 9.01875 6.62187 8.88125 6.82812L6.1625 10.8156L5.33437 9.78125C5.19062 9.60312 4.975 9.5 4.75 9.5C4.525 9.5 4.30625 9.60312 4.16563 9.78125L2.16563 12.2812C1.98438 12.5063 1.95 12.8156 2.075 13.075C2.2 13.3344 2.4625 13.5 2.75 13.5H5.75H6.75H13.25C13.5281 13.5 13.7844 13.3469 13.9125 13.1C14.0406 12.8531 14.025 12.5562 13.8687 12.3281L10.1187 6.82812ZM3.5 6.5C3.89782 6.5 4.27936 6.34196 4.56066 6.06066C4.84196 5.77936 5 5.39782 5 5C5 4.60218 4.84196 4.22064 4.56066 3.93934C4.27936 3.65804 3.89782 3.5 3.5 3.5C3.10218 3.5 2.72064 3.65804 2.43934 3.93934C2.15804 4.22064 2 4.60218 2 5C2 5.39782 2.15804 5.77936 2.43934 6.06066C2.72064 6.34196 3.10218 6.5 3.5 6.5Z"
            fill="#6466F1"
          />
        </svg>
)